import type { Promotion } from "../../../api/catalog";
import type { PriceBook } from "../../../api/catalog";
import type { Product } from "../../../api/catalog";

type PromotionTabCiblageProps = {
  promotion: Promotion;
  priceBooks: PriceBook[];
  products: Product[];
  isLocked: boolean;
};

export function PromotionTabCiblage({
  promotion,
  priceBooks,
  products,
}: PromotionTabCiblageProps) {
  const scopeLabel =
    promotion.scope === "all_products"
      ? "Tous les produits"
      : promotion.scope === "selected_products"
      ? "Produits sélectionnés"
      : "Par catégories";

  const targetNames = (promotion.target_price_book_ids || [])
    .map((id) => priceBooks.find((pb) => pb.id === id)?.name)
    .filter(Boolean);

  const includedProducts =
    promotion.scope === "selected_products" && promotion.product_ids?.length
      ? promotion.product_ids
          .map((id) => products.find((p) => p.id === id))
          .filter(Boolean) as Product[]
      : [];

  const excludedProducts = (promotion.excluded_product_ids || [])
    .map((id) => products.find((p) => p.id === id))
    .filter(Boolean) as Product[];

  return (
    <div className="space-y-6">
      <h3 className="text-sm font-semibold text-text">Ciblage</h3>

      <div className="rounded-md border border-border bg-surface p-4 space-y-4">
        <div>
          <label className="text-xs text-muted">PriceBooks ciblés</label>
          <p className="text-xs text-muted mt-0.5">
            La promotion s'applique seulement aux prix issus de ces pricebooks.
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            {targetNames.map((n) => (
              <span
                key={n}
                className="inline-flex rounded-full px-2 py-1 text-xs font-medium bg-primary/10 text-primary"
              >
                {n}
              </span>
            ))}
            {targetNames.length === 0 && <span className="text-sm text-muted">Aucun</span>}
          </div>
        </div>

        <div>
          <label className="text-xs text-muted">Portée</label>
          <div className="mt-1 text-sm text-text">{scopeLabel}</div>
        </div>

        {includedProducts.length > 0 && (
          <div>
            <label className="text-xs text-muted">Produits inclus ({includedProducts.length})</label>
            <ul className="mt-1 text-sm text-text list-disc list-inside space-y-0.5">
              {includedProducts.slice(0, 20).map((p) => (
                <li key={p.id}>{p.name}</li>
              ))}
              {includedProducts.length > 20 && (
                <li className="text-muted">… et {includedProducts.length - 20} autres</li>
              )}
            </ul>
          </div>
        )}

        {excludedProducts.length > 0 && (
          <div>
            <label className="text-xs text-muted">Produits exclus ({excludedProducts.length})</label>
            <ul className="mt-1 text-sm text-text list-disc list-inside space-y-0.5">
              {excludedProducts.slice(0, 10).map((p) => (
                <li key={p.id}>{p.name}</li>
              ))}
              {excludedProducts.length > 10 && (
                <li className="text-muted">… et {excludedProducts.length - 10} autres</li>
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
